import React from 'react';

export default function TermsOfUse() {
    return (
        <section className="bg-gradient-to-br from-blue-100 via-purple-100 to-pink-100 p-6 rounded-lg text-gray-800 overflow-y-auto">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">Terms and Conditions</h2>
            <p className="mb-4">
                Welcome to our website. If you continue to browse and use this website, you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern [Your Company Name]'s relationship with you in relation to this website. If you disagree with any part of these terms and conditions, please do not use our website.
            </p>

            <h3 className="text-xl font-semibold mt-4 text-gray-900">Use of the Website</h3>
            <p className="mb-4">
                The content of the pages of this website is for your general information and use only. It is subject to change without notice.
            </p>

            <h3 className="text-xl font-semibold mt-4 text-gray-900">Intellectual Property</h3>
            <p className="mb-4">
                This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
            </p>

            <h3 className="text-xl font-semibold mt-4 text-gray-900">Limitation of Liability</h3>
            <p className="mb-4">
                Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through this website meet your specific requirements.
            </p>

            <h3 className="text-xl font-semibold mt-4 text-gray-900">Governing Law</h3>
            <p className="mb-4">
                These terms and conditions are governed by and construed in accordance with the laws of [Your Country/State] and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
            </p>
        </section>
    );
}